export default __webpack_public_path__ + "static/media/1315.617238e2.png";